// extracted by mini-css-extract-plugin
module.exports = {"post__footer":"Post-module--post__footer--1BvmJ","post__comments":"Post-module--post__comments--2T8dL","post__home-button":"Post-module--post__home-button--3zx_9"};